import { Component, Input, OnInit } from "@angular/core";
import { GroupedStatus } from "src/app/models/GroupedStatus";
import { Tool } from "src/app/models/Tool";

import { ToolService } from "./../../services/tool.service";

@Component({
  selector: "status-timeline",
  templateUrl: "./status-timeline.component.html",
  styleUrls: ["./status-timeline.component.scss"],
  standalone: false,
})
export class StatusTimelineComponent implements OnInit {
  @Input() tool: Tool;
  groupedStatuses: GroupedStatus[];
  currentStatus: GroupedStatus;

  constructor(private toolService: ToolService) {}

  ngOnInit() {
    this.groupedStatuses = this.toolService.statuses;
    this.currentStatus = this.groupedStatuses.find((x) => x.value == this.tool.eventStatus);
  }

  isActive(status: GroupedStatus): boolean {
    if (!this.currentStatus) return false;

    return status.key <= this.currentStatus.key;
  }

  isCurrent(status: GroupedStatus): boolean {
    return status.value === this.tool.eventStatus;
  }
}
